<template>
    <PeopleAvatar :size="size" :initials="initial" :letters="letters" :disabled="disabled || !getPerspectiveSwatch(letters)" />
</template>

<script setup lang="ts">
import { type BaseAvatarSize } from "~vue/components/BaseAvatar.vue";
import PeopleAvatar from "~vue/components/PeopleAvatar.vue";
import { getAvatarInitials } from "~vue/utils/avatarUtils";
import { getPerspectiveSwatch } from "~vue/utils/perspectivePalette";
import { computed } from "vue";

const {
    name,
    letters,
    size = "md",
    disabled = false,
} = defineProps<{
    name?: string | null;
    letters?: string | null;
    size?: BaseAvatarSize;
    disabled?: boolean;
}>();

const initial = computed(() => getAvatarInitials(name).charAt(0));
</script>
